module.exports = new __parcel__URL__("pet_button.2bdab15c.png").toString();